export default __webpack_public_path__ + "static/media/arrow-right-white.02fa4aad.svg";